// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__XZLin"};